export enum FilterTypeEnum {
    Pos = "pos",
    Channel = "channel",
    Service = "service",
    OfferType = "offerType",
    Audience = "audience",
    Weekdays = "weekdays",
    TimeSpendList = "timeSpendList",
    ActionType = "actionType",
    Discount = "discount",
    MinBasket = "minBasket",
    State = "state",

    // ADMIN Filters
    User = "user",
}
